import { AxiosResponse } from "axios";
import { axiosInstance } from "./axiosInstance";
import { CoursePlanBody, CoursePlanDTO, HolidayReplacementBody, ScheduleHolidaysDTO } from "../../models/CoursePlanDTO";

const RESOURCE_URL_V2 = "/admin/campus/";

/** Plan de pagos por curso y asuetos por horario (FASE 3 Matrícula por curso). */
export class CoursePlanService {

	/** 404 si el curso es de otro plantel. */
	getPlan = async (campusId: number, courseId: number): Promise<AxiosResponse<CoursePlanDTO>> =>
		axiosInstance.get<CoursePlanDTO>(`${RESOURCE_URL_V2}${campusId}/courses/${courseId}/_plan`);

	/** Solo afecta matrículas nuevas. */
	savePlan = async (campusId: number, courseId: number, body: CoursePlanBody): Promise<AxiosResponse<CoursePlanDTO>> =>
		axiosInstance.put<CoursePlanDTO>(`${RESOURCE_URL_V2}${campusId}/courses/${courseId}/_plan`, body);

	/** Historial de precios: nuevo precio desde un mes ("2027-01"). */
	addPrice = async (campusId: number, courseId: number, body: { desde: string; monthlyPrice: number; billableMonths: number; note?: string }): Promise<AxiosResponse<CoursePlanDTO>> =>
		axiosInstance.post<CoursePlanDTO>(`${RESOURCE_URL_V2}${campusId}/courses/${courseId}/_prices`, body);

	/** Solo un precio que nadie ha usado. */
	deletePrice = async (campusId: number, courseId: number, priceId: number): Promise<AxiosResponse<CoursePlanDTO>> =>
		axiosInstance.delete<CoursePlanDTO>(`${RESOURCE_URL_V2}${campusId}/courses/${courseId}/_prices/${priceId}`);

	getScheduleHolidays = async (campusId: number, scheduleId: number, from?: string, to?: string): Promise<AxiosResponse<ScheduleHolidaysDTO>> =>
		axiosInstance.get<ScheduleHolidaysDTO>(`${RESOURCE_URL_V2}${campusId}/academicCalendar/_schedule`, { params: { scheduleId, from, to } });

	/** Asueto solo de este horario; con replacement = "reponer el <fecha> en <aula>". */
	addScheduleHoliday = async (campusId: number, body: { scheduleId: number; date: string; name: string; notes?: string; replacement?: HolidayReplacementBody }): Promise<AxiosResponse<any>> =>
		axiosInstance.post(`${RESOURCE_URL_V2}${campusId}/academicCalendar`, { typeId: 2, ...body });

	deleteHoliday = async (campusId: number, holidayId: number): Promise<AxiosResponse<any>> =>
		axiosInstance.delete(`${RESOURCE_URL_V2}${campusId}/academicCalendar/${holidayId}`);

	/** 422 si la sesión ya tiene asistencias. */
	setReplacement = async (campusId: number, holidayId: number, scheduleId: number, body: HolidayReplacementBody): Promise<AxiosResponse<any>> =>
		axiosInstance.put(`${RESOURCE_URL_V2}${campusId}/academicCalendar/_replacement`, { holidayId, scheduleId, ...body });

	removeReplacement = async (campusId: number, holidayId: number, scheduleId: number): Promise<AxiosResponse<any>> =>
		axiosInstance.delete(`${RESOURCE_URL_V2}${campusId}/academicCalendar/_replacement`, { params: { holidayId, scheduleId } });
}

const coursePlanService = new CoursePlanService();

export default coursePlanService;
